import { createContext, type FC, type PropsWithChildren, useContext, useState, useMemo } from "react";

type SoftReRender = {
	value: number;
	softReRender(): void;
};

const SoftReRenderContext = createContext<SoftReRender>({ value: 0, softReRender: () => {} });

export const SoftReRenderProvider: FC<PropsWithChildren> = ({ children }) => {
	const [value, setValue] = useState(0);

	const softReRender = useMemo(() => {
		return () => setValue((prev) => prev + 1);
	}, []);

	return <SoftReRenderContext value={{ value, softReRender }}>{children}</SoftReRenderContext>;
};

export function useSoftReRenderValue() {
	return useContext(SoftReRenderContext).value;
}

function useSoftReRender() {
	return useContext(SoftReRenderContext).softReRender;
}
export default useSoftReRender;
